import React from 'react';
import classNames from 'classnames';

import { Link, Translation } from '../../common';

import styles from './troy.module.scss';
import TroyLogo from '../../common/Logo/Logo.troy';
import logo from '../../../assets/img/logos/troy/troy_footer.png';

/* removed from footer
import visa_maestro from '../../../assets/img/payment/visa-maestro-gray.png';
import paypal from '../../../assets/img/payment/paypal-icon.png';
*/

import { COMPANY_INFO, CONFIDENTIALITY } from '../../../constants/routes';
import { DE, NL } from '../../../constants/browser';

import { onClickWrapper } from '../../../utils/ui';

import Footer from '.';

const EMAIL_KEY = 'TROY_EMAIL';
const PHONE_KEY = 'TROY_PHONE';
const FAX_KEY = 'TROY_FAX';

const columns = {
  [DE]: [
    ({ styles }) => <Translation>TROY_ADDRESS</Translation>,
    ({ styles, translations }) => (
      <>
        <Link
          raw
          id="page.component.footer.email-link"
          className={styles['footer__info-link']}
          to={`mailto:${translations[EMAIL_KEY]}`}
        >
          <Translation>{EMAIL_KEY}</Translation>
        </Link>
        <Link
          raw
          id="page.component.footer.phone-link"
          className={styles['footer__info-link']}
          to={`tel:${translations[PHONE_KEY]}`}
        >
          <Translation>{PHONE_KEY}</Translation>
        </Link>
        <Link
          raw
          id="page.component.footer.fax-link"
          className={styles['footer__info-link']}
          to={`fax:${translations[FAX_KEY]}`}
        >
          <Translation>{FAX_KEY}</Translation>
        </Link>
      </>
    ),
    ({ styles, isAuthenticated, logout }) => (
      <>
        <Link
          id="page.component.footer.home-link"
          className={styles['footer__info-link-home']}
          to="https://www.troy-bleiben.de"
          raw
        >
          <Translation>NAVBAR_HOME</Translation>
        </Link>
        <div>
          <Link
            id="page.component.footer.imrpint-link"
            className={styles['footer__info-link']}
            to={COMPANY_INFO}
          >
            <Translation>NAVBAR_IMPRINT</Translation>
          </Link>
        </div>
        <div>
          <Link
            id="page.component.footer.cookies-link"
            className={styles['footer__info-link']}
            to={CONFIDENTIALITY}
          >
            <Translation>NAVBAR_COOKIES&DATAPROTECTION</Translation>
          </Link>
        </div>
        {isAuthenticated && (
          <div
            className={styles['footer__info-link']}
            onClick={onClickWrapper(
              'page.component.footer.logout-button',
              () => logout()
            )}
          >
            <Translation>LOGOUT_BUTTON</Translation>
          </div>
        )}
      </>
    ),
    ({ styles }) => (
      <div className={styles['footer__info-bank']}>
        <div className={styles['footer__info-table']}>
          <div className={styles['footer__info-table-row']}>
            <div
              className={classNames(
                styles['footer__info-table-cell_bold'],
                styles['footer__info-table-cell_side-padding']
              )}
            >
              IBAN
            </div>
            <Translation className={styles['footer__info-table-cell']}>
              IBAN
            </Translation>
          </div>
          <div className={styles['footer__info-table-row']}>
            <div
              className={classNames(
                styles['footer__info-table-cell_bold'],
                styles['footer__info-table-cell_side-padding']
              )}
            >
              BIC
            </div>
            <Translation className={styles['footer__info-table-cell']}>
              BIC
            </Translation>
          </div>
        </div>
        <div className={styles['footer__payments']}></div>
      </div>
    ),
  ],
  [NL]: [
    ({ styles }) => <Translation>TROY_ADDRESS</Translation>,
    ({ styles, translations }) => (
      <>
        <Link
          raw
          id="page.component.footer.home-link"
          className={styles['footer__info-link-home_nl']}
          to="https://www.troy.nl"
        >
          www.troy.nl
        </Link>
        <Link
          raw
          id="page.component.footer.email-link"
          className={styles['footer__info-link_nl']}
          to={`mailto:${translations[EMAIL_KEY]}`}
        >
          <Translation>{EMAIL_KEY}</Translation>
        </Link>
        <Link
          raw
          id="page.component.footer.phone-link"
          className={styles['footer__info-link_nl']}
          to={`tel:${translations[PHONE_KEY]}`}
        >
          <Translation>{PHONE_KEY}</Translation>
        </Link>
      </>
    ),
    ({ styles }) => (
      <>
        <div>
          <Link
            id="page.component.footer.imprint-link"
            className={styles['footer__info-link_nl']}
            to={COMPANY_INFO}
          >
            <Translation>NAVBAR_IMPRINT</Translation>
          </Link>
        </div>
        <div>
          <Link
            id="page.component.footer.cookies-link"
            className={styles['footer__info-link_nl']}
            to={CONFIDENTIALITY}
          >
            <Translation>NAVBAR_COOKIES&DATAPROTECTION</Translation>
          </Link>
        </div>
      </>
    ),
    ({ styles, isAuthenticated, logout }) =>
      isAuthenticated ? (
        <div
          className={classNames(
            styles['footer__info-link_nl'],
            styles['footer__logout_nl']
          )}
          onClick={onClickWrapper('page.component.footer.logout-button', () =>
            logout()
          )}
        >
          <Translation>LOGOUT_BUTTON</Translation>
        </div>
      ) : null,
  ],
};

const LogoComponent = () => (
  <TroyLogo className={styles['footer__logo-image']} src={logo} />
);

const TroyFooter = ({ isAuthenticated, logout }) => (
  <Footer {...{ styles, columns, isAuthenticated, LogoComponent, logout }} />
);

TroyFooter.propTypes = {};

export default TroyFooter;
